import { httpRequest } from '@/shared/lib/http'

// CC-03 (SP-250). Permiso del back: proveedores.administracion.proveedores.editar.
// POST  /admin/suppliers/:id/reset-password → { password }
// PATCH /admin/suppliers/:id/account-email  → { email }
// 400 si el correo es igual al actual, 409 si ya lo tiene otra cuenta o una
// invitación activa. Los dos cierran las sesiones abiertas del proveedor y le
// avisan por correo; la contraseña nunca vuelve en la respuesta.

export const restablecerContrasena = (supplierId: string, password: string) =>
  httpRequest<{ success: boolean; message: string }>(
    `/admin/suppliers/${supplierId}/reset-password`,
    { method: 'POST', body: JSON.stringify({ password }), token: 'staff' },
  )

export const cambiarCorreoDeAcceso = (supplierId: string, email: string) =>
  httpRequest<{ success: boolean; message: string; email: string }>(
    `/admin/suppliers/${supplierId}/account-email`,
    { method: 'PATCH', body: JSON.stringify({ email }), token: 'staff' },
  )
